import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import settings from "../../../devices/all/settings";
class PBIFromRegisterTask extends AbstractRequestTask {
  constructor(params) {
    super();

    this.params = params;
  }

  getHeaders() {
    const params = super.getParams();
    return {
        'Content-Type': 'application/json',
        'user-token': params.user_token
    };
  }

  getUrl() {
    if(settings.fake_url_mockoon) {
      return `${settings.fake_url_mockoon}/services/payway/purchasebuttoninfo`;
    }
    else {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");
      return `${http}${url}/services/payway/v1/purchasebuttoninfo`;
    } 
  }

  getParams() {
    const params = super.getParams();
    delete params.HKS;
    delete params.user_token;
    delete params.api_version;
    return {
        object_type: this.params.object_type,
      ...params,
    };
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default PBIFromRegisterTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/payway/PBIFromRegisterTask.js